import React, {Suspense} from 'react'
import {Route, Switch} from 'react-router-dom'

import PageLoader from '@progyny/components/PageLoader'
import {RouteEnum, useRoutes} from '@progyny/routes'

const AprylNavigatorHome = React.lazy(
  () => import('@progyny/pages/AprylNavigator/Home')
)

const AprylNavigatorRoutes = () => {
  const {getPath} = useRoutes()

  return (
    <Suspense fallback={<PageLoader position={'top'} />}>
      <Switch>
        <Route
          exact
          path={getPath(RouteEnum.APRYL_NAVIGATOR)}
          component={AprylNavigatorHome}
        />
      </Switch>
    </Suspense>
  )
}

export default AprylNavigatorRoutes
